import { GameWinDisplayProperties } from "@lib/js-slingo-pawnshop-core/dist/game/view/abstract/properties/GameWinDisplayProperties";
import { ControlConstants } from "@lib/titan2/dist/game/control/constant/ControlConstants";
import * as PIXI from "pixi.js";
/**
 * WinDisplayLandscapeProperties.ts
 */
export class WinDisplayLandscapeProperties extends GameWinDisplayProperties {
    setDefaultValues() {
        super.setDefaultValues();
        this.gameOverProperties.position = new PIXI.Point(900, 360);
        this.scale.set(0.7);
        this.gameOverFieldProperties.verticalAlign = ControlConstants.CENTER;
        this.gameOverFieldProperties.horizontalAlign = ControlConstants.CENTER;
        this.gameOverFieldProperties.position = new PIXI.Point(460, 30);
        this.gameOverFieldProperties.size = new PIXI.Point(900, 300);
    }
}
